var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveMountainComplex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linka"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.6 264.2l19.6-13.7 17.6-14.7h19.5l19.6-1.9 13.6-7.8 36.2 7.8 15.6-2 22.5-9.7 16.6-12.7 22.5 4.8 16.6-7.8 26.4 27.4 20.5 20.5 32.3 12.7 7.8 8.8 19.5 14.7 3 8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M469.7 278l.7 3.1h-2.7V278z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.8 278l-.7 3.1h2.6V278z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M467.7 261.9l-12.5 17.2 8.2-2.1 4.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M467.7 256.4l-10.5 14.4 6.9-1.8 3.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M467.7 252.6l-7.8 10.8 5.1-1.3 2.7 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.7 261.9l12.6 17.2-8.2-2.1-4.4 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.7 256.4l10.6 14.4-6.9-1.7-3.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M467.7 252.6l7.9 10.8-5.1-1.3-2.8 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M382.3 271.1l.6 3.1h-2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3 271.1l-.6 3.1h2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M380.3 255.1l-12.5 17.1 8.1-2.1 4.4 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M380.3 249.6L369.7 264l6.9-1.8 3.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M380.3 245.8l-7.9 10.7 5.2-1.3 2.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.3 255.1l12.5 17.1-8.2-2.1-4.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.3 249.6l10.5 14.4-6.9-1.8-3.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M380.3 245.8l7.9 10.7-5.2-1.3-2.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M441.2 274.1l.7 3.5h-3v-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7 274.1l-.7 3.5h2.9v-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M438.9 256l-14.1 19.3 9.2-2.3 4.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M438.9 249.7L427 266l7.8-2 4.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M438.9 245.4l-8.9 12.2 5.8-1.5 3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M438.9 256l14.2 19.3-9.3-2.3-4.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M438.9 249.7l11.9 16.3-7.8-2-4.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M438.9 245.4l8.9 12.2-5.8-1.5-3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M590.6 321.1l73.9-18.7 32.1 3.7 32.2-13.9 35.3-2 18.1-10.2 11.7.6 3-.6 5.4-5.6 18.9 2.3 37.7 10.6 19.5 7.5 14-3 10.3.5 14.5 2.9 7.9 4.7 21.9 1.8 20.7-3.4 43.7 7.2 23.9 6.2h30.8l26.9-9.7 26.1-8.3 33.6 1.6 15.2-11.1 18.7-6.4 14.1-4.5 11.4-6.8 22.1-2.6 27.8 1.3 15.6-3 26-8.3 23.5.4 6.4 4 19.7 2.4 15.4.7 15.2 4.4 23.9 6.2 2.2.1 18.2 3.8 7.3-1.1 18.1-9.4 26.9-11.2 4.6-3.5 37.4-14.4 13.5-7.4 18.1 7.1 47.9-6.2 6.4 4.7 17.9 9.7 29 7.2 5.6 5.4 27.1 15.9 5.2 14.2 19.5 8.3 12.8 8.7 12 9.3 14.2 10.2 21.1 19.4-190 60.7-770.6 21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1294.2 381.4l1.1 5.5h-4.4v-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287.7 381.4l-1.1 5.5h4.3v-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1290.9 353.1l-20.6 30.2 13.5-3.7 7.1 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1290.9 343.3l-17.4 25.4 11.4-3.1 6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1290.9 336.6l-13 19 8.5-2.3 4.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1290.9 353.1l20.7 30.2-13.5-3.7-7.2 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1290.9 343.3l17.5 25.5-11.4-3.2-6.1 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1290.9 336.6l13.1 19-8.6-2.3-4.5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1259.7 381.7l.8 4h-3.4v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.6 381.7l-.8 4h3.3v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1257.1 361.4l-15.9 21.7 10.4-2.7 5.5 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1257.1 354.3l-13.4 18.3 8.8-2.2 4.6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1257.1 349.5l-10 13.7 6.6-1.7 3.4 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1257.1 361.4l16 21.7-10.4-2.6-5.6 2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1257.1 354.3l13.5 18.3-8.8-2.2-4.7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1257.1 349.5l10 13.7-6.5-1.7-3.5 1.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1332.1 383.6l.8 4h-3.3v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.1 383.6l-.8 4h3.3v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1329.6 363.2l-15.9 21.8 10.4-2.7 5.5 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1329.6 356.2l-13.4 18.3 8.8-2.2 4.6 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1329.6 351.4l-10 13.6 6.6-1.6 3.4 1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1329.6 363.2l15.9 21.8-10.4-2.7-5.5 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1329.6 356.2l13.4 18.3-8.7-2.2-4.7 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1329.6 351.4l10 13.6-6.5-1.6-3.5 1.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1205.1 376.2l.6 3.2h-2.6v-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.1 376.2l-.6 3.2h2.6v-3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1203.1 360.2l-12.5 17.1 8.2-2.1 4.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1203.1 354.7l-10.6 14.4 6.9-1.8 3.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1203.1 350.9l-7.9 10.7 5.2-1.3 2.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1203.1 360.2l12.5 17.1-8.2-2.1-4.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1203.1 354.7l10.5 14.4-6.9-1.8-3.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1203.1 350.9l7.9 10.7-5.2-1.3-2.7 1.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1168 375.8l.5 2.7h-2.2v-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164.7 375.8l-.6 2.7h2.2v-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1166.3 362.3l-10.5 14.5 6.9-1.8 3.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1166.3 357.6l-8.9 12.2 5.8-1.5 3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1166.3 354.5l-6.6 9 4.3-1.1 2.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1166.3 362.3l10.6 14.5-6.9-1.8-3.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1166.3 357.6l8.9 12.2-5.8-1.5-3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1166.3 354.5l6.7 9-4.4-1.1-2.3 1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6_00000131339049436002151560000003714746241000512686_",
    className: "st9",
    d: "M-1.6 446.8l.2-137.5c17.5-7 37.1-13.9 55.1-19.3 20.8-6.2 42.2-11.5 63.6-15.7 11.2-2.2 22.7-4.1 34-5.7 11.7-1.7 23.6-3 35.5-4.1 18.6-1.7 40.3-2.5 64.3-2.5 22.7 0 48.1.8 75.7 2.2 25.9 1.4 54.5 3.5 84.8 6.2 28.3 2.5 59 5.7 91.4 9.4 29.8 3.4 61.9 7.4 95.4 11.8 57.3 7.6 120.3 16.7 192.6 27.8 62.8 9.7 123.8 19.5 177.7 28.2H969l7 1.1c55 8.9 111.2 16 167.1 21.2 33.2 3.1 66.6 5.5 99.1 7.1 35.9 1.8 71.6 2.7 106.1 2.7 20.4 0 40.9-.3 60.8-.9 20.8-.7 41.6-1.7 61.7-3 21-1.4 42-3.2 62.2-5.3 21.1-2.2 42-4.9 62.3-7.9 44.6-6.6 90.6-12.9 136.9-18.7 43.1-5.4 126.2-13.2 159.4-15 34-1.8 98.9-.6 98.9-.6h10.2v117.6l-2002.3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M721.3 308.7s87 10.7 98 11.7 42 3.5 49.5 3.5 15 3.5 25.5 6.5 32 4.5 38.5 6 57 11 60.5 12 9.8 4.8 9.8 4.8l13.9 2s-1.7-3.2 13.3-2.7 31 2.5 35 1.5 24 6 29 7 44.5 6.5 46 8.5-25.5 7.5-32.5 7-29.5-2-33-.5-47.5 6-53 7.5-31 2-46 1-81-5-85-5.5-96-26.5-106-29-51.2-23.7-56.2-26.2-33.5-16.2-28-17.7c3.4 0 13.7 1.6 20.7 2.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1480.6 379.3l.6 3.1h-2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.6 379.3l-.6 3.1h2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1478.6 363.3l-12.5 17.1 8.2-2.1 4.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1478.6 357.7l-10.5 14.4 6.9-1.7 3.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1478.6 353.9l-7.9 10.8 5.2-1.3 2.7 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1478.6 363.3l12.5 17.1-8.2-2.1-4.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1478.6 357.7l10.6 14.4-6.9-1.7-3.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1478.6 353.9l7.9 10.8-5.2-1.3-2.7 1.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M803.6 328.6l.6 3.1h-2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.6 328.6l-.6 3.1h2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M801.6 312.6l-12.5 17.1 8.1-2.1 4.4 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M801.6 307L791 321.4l6.9-1.7 3.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M801.6 303.2l-7.9 10.8 5.1-1.3 2.8 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M801.6 312.6l12.5 17.1-8.2-2.1-4.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M801.6 307l10.5 14.4-6.9-1.7-3.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M801.6 303.3l7.8 10.7-5.1-1.3-2.7 1.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1017 355.1s7.6 3.7 25.1 16.5c17.1 13.7 16.7 24.8.2 46.2-10.5 16.7 25.9 30.3 25.9 30.3s-23.3 1.1-28.9 0c-5.6-1.1-27.1-.2-27.1-.2s-9-11.9-7.3-26.7 35.3-23.4 28.2-38.6c-7.1-15.2-30-29.5-30-29.5l13.9 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M329 264.4s28-.3 31-.3 35 3.3 40 3.3 29 .7 30.7 1c1.7.3 21.7 4.7 24.7 4.7s27.7 4.3 27.7 4.3-4.7 2.7-11.3 3c-6.7.3-27.7-.7-29.3.3-1.7 1-22.7 6.7-36 5-13.3-1.7-33.3-6.3-40-8.3s-15.3-7.3-19.7-8.3c-4.5-1-16.8-3-17.8-4.7zM343.8 284.9s15 1 18.5 3 15.5 3 16.5 4.5-10.5 3.5-19 3.5-25-1.5-30-2.5-15-5.5-8-6.5 22-2 22-2zM317 277.1s5.5 3 10.5 2 9.7-2.2 10.8-2.3c1.2-.2 1.8-2.2-8.7-2.7s-23.3-1-12.6 3zM438 294.4s38.9.3 67.3 1.3 41.4 4.1 77 8.2 104.8 26.6 108.9 28.6c30 9.7-85.1 10.3-100 10.3s-81 6.7-105.2 6.2c-24.2-.5-80.4-28.9-88.2-33-7.7-4.1-9.8-19.1 40.2-21.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M417.5 302.7l.5 2.6h-2.2v-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.1 302.7l-.5 2.6h2.2v-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.8 289.2l-10.6 14.4 6.9-1.7 3.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.8 284.5l-8.9 12.2 5.8-1.5 3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M415.8 281.3l-6.6 9.1 4.3-1.1 2.3 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.8 289.2l10.6 14.4-6.9-1.7-3.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.8 284.5l8.9 12.2-5.8-1.5-3.1 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M415.8 281.3l6.6 9.1-4.3-1.1-2.3 1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1149.8 399.4s49.4.7 68.2.8c18.8.2 69.8 11.2 79.8 12.7s-77 7.5-96 6.5-64-13.5-69.5-15 .5-4.5 17.5-5zM1248.3 388.1s35.7 8 47.7 7.7c12-.3 40-2.3 48.3-4.3 8.3-2 57 6.3 67.7 2.3 10.7-4 37.3-7 42-10.3 4.7-3.3 12.7-4.7 12.7-6 0-1.3-15.5-.4-17.1-.2s-54.5 2.4-60.1 2.2c-5.6-.1-61.5.4-67.5 0s-72.6-2-84.3-3c-11.7-1-33-1.5-35.6-1.7-2.3.1 2.1 2.4 9.4 3.4 7.2.6 31.8 9.4 36.8 9.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1361.7 396.8l.6 3.1h-2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.7 396.8l-.6 3.1h2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1359.7 380.8l-12.5 17.1 8.2-2.1 4.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1359.7 375.2l-10.6 14.4 6.9-1.7 3.7 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1359.7 371.4l-7.9 10.8 5.2-1.3 2.7 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1359.7 380.8l12.5 17.1-8.2-2.1-4.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1359.7 375.2l10.5 14.4-6.9-1.7-3.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1359.7 371.4l7.9 10.8-5.2-1.3-2.7 1.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1399.9 385.8l.6 3.1h-2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.9 385.8l-.6 3.1h2.6v-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1397.9 369.7l-12.5 17.2 8.1-2.1 4.4 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1397.9 364.2l-10.6 14.4 6.9-1.8 3.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1397.9 360.4l-7.9 10.8 5.2-1.3 2.7 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1397.9 369.7l12.5 17.2-8.2-2.1-4.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1397.9 364.2l10.5 14.4-6.9-1.7-3.6 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1397.9 360.4l7.9 10.8-5.2-1.3-2.7 1.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1229.6 404.2l.9 4.7h-4v-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1223.5 404.2l-1 4.7h4v-4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1226.5 379.8l-19.1 26 12.5-3.2 6.6 2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1226.5 371.3l-16.1 22 10.6-2.7 5.5 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1226.5 365.6l-12 16.3 7.9-2 4.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1226.5 379.8l19.1 26-12.5-3.1-6.6 2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1226.5 371.3l16.1 22-10.5-2.7-5.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1226.5 365.6l12 16.3-7.8-2-4.2 1.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1549.3 368.4s69.5-11 91-15.5 62.5-9 76-9 37.5-3 39-2.5-10.5 4.5-25 8.5-42.5 17.5-57 22-59.6 14.2-75.6 12.8-51.1-5.5-58.6-6.5-16.1-4-16.5-6c-.5-1.5 12.2-1.5 26.7-3.8zM1690.3 397.4s29-6 39.5-5 29.5 4.5 24 5.5-31.5 8-49 7.5-34-3-36.5-3.5 8.5-4.5 22-4.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M679.9 344.6l.8 3.9h-3.3v-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.8 344.6l-.8 3.9h3.4v-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M677.4 324.2l-16 21.8 10.4-2.7 5.6 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M677.4 317.1l-13.5 18.4 8.8-2.3 4.7 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M677.4 312.3L667.3 326l6.6-1.7 3.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M677.4 324.2l15.9 21.8-10.4-2.7-5.5 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M677.4 317.1l13.4 18.4-8.8-2.3-4.6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M677.4 312.3l10 13.7-6.6-1.7-3.4 1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M726.5 350.2s28.5 2 38 3 19.5 8.5 10.5 8.5-38 9-53 6-31.5-6.5-27-11 18.5-7.5 31.5-6.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M735.7 353.8l1.3 6.5h-5.5v-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.4 353.8l-1.3 6.5h5.4v-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M731.5 320.2l-26.2 35.9 17.2-4.4 9 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M731.5 308.5l-22.1 30.3 14.5-3.7 7.6 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M731.5 300.6l-16.4 22.6 10.7-2.8 5.7 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M731.5 320.2l26.3 35.9-17.2-4.4-9.1 3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M731.5 308.6l22.2 30.2-14.5-3.7-7.7 3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M731.5 300.6l16.5 22.6-10.7-2.8-5.8 2.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1488.6 254.4l20-5.7 24.7-10 17 5.7 51.3-8.3 22 14.3 26.7 19 24 4 12.3 14.3-16.6-11-31 1-18.4-7.6-12.6-11-18.7 1-13.7-3.7-14 4-11.3.3-18.3 10.7-4 6.7.6-8.7 4.7-9.7-12.7-2-21.3 1.7zM1603.8 296.4l25.5 2 23 6.5 18 14-27.5-5-24.5-10.5-32.5-2zM1273.8 267.9l33-6.5 49.5 4 35 8.5 23.5 3.5-30.5 3-30.5-3.5-25 5.5-20 2-16-8.5-21 2-14 4zM803.3 278.4l17 2 46 15-28.5-1-26.5-5-17.5 3.5-14-2.5-20.5 8 24.5-14.5 13 1zM956.6 304.7l19-.5 53 10 41.5 2 52.5-16.5 24 1-16.5 13-40.5 5-17.5 6.5h-42.5l-52.5-16zM493.4 278.7l43.3 4.5 54.5 7.1 29.2 4.2-21.2 1.1-48.2-.9s-26-7.7-35.8-8.8c-9.9-1.1-21.8-7.2-21.8-7.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M546.7 301l.6 3.1h-2.6V301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.7 301l-.6 3.1h2.6V301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M544.7 285l-12.5 17.1 8.2-2.1 4.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M544.7 279.5l-10.5 14.4 6.9-1.8 3.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M544.7 275.7l-7.9 10.7 5.2-1.3 2.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M544.7 285l12.5 17.1-8.2-2.1-4.3 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M544.7 279.5l10.6 14.4-6.9-1.8-3.7 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M544.7 275.7l7.9 10.7-5.2-1.3-2.7 1.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M507.7 303.7l1.1 5.1h-4.3v-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.2 303.7l-1 5.1h4.3v-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.5 277.6L484 305.5l13.4-3.4 7.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.5 268.5l-17.2 23.6 11.2-2.9 6 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M504.5 262.3l-12.9 17.6 8.4-2.1 4.5 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M504.5 277.6l20.4 27.9-13.3-3.4-7.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M504.5 268.5l17.2 23.6-11.2-2.9-6 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M504.5 262.3l12.8 17.6-8.4-2.1-4.4 1.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1409.8 288.9s-36.5 10-38 10.5-23 15-29 17-27.5 11.5-27.5 11.5l29-6.5 24.5-9 23-1.5 15-4 28 2s30 12.5 36 14 41 6 41 6l23.5-1.5s-37-6-39.5-7-34.5-21.5-34.5-21.5l-24.5-5-11-9-16 4zM455.6 231.7l19.7-8.3 11-9.3 15 3.6 10.7 7.4-1.7-7.4 9-2 18.7 22 21 15-36.4-14.3-21.3-2-12.7-7-14.6 3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMountainComplex);
export default __webpack_public_path__ + "static/media/waveMountainComplex.2dc2fca6175dca278f0c7029dd6f6f67.svg";
export { ForwardRef as ReactComponent };